<template>
  <main>
    <div class="main-container">
      <div class="row" >
        <div class="col s12 l10 offset-l1 card-panel">
          <div class="row center-align" style="margin-bottom: 0%;">
            <div class="page-title">
              <span>Gráficas</span>
            </div>
            <div class="row center-align" style="margin-bottom: 0%;">
              <div class="col s2 offset-s4 input-date" style="cursor: pointer;">
                <link
                  rel="stylesheet"
                  href="https://fonts.googleapis.com/css2?family=Material+Symbols+Outlined:opsz,wght,FILL,GRAD@20..48,100..700,0..1,-50..200"
                />
                <div class="center-align" @click="dateIni">
                  <span
                    class="material-symbols-outlined btn-style color"
                    style="position: relative; top: 4px;"
                    >today</span
                  >
                  <span
                    class="prefix"
                    style="font-size: 18px; width: 6rem; top: 0.2rem;"
                    >Fecha Inicial:</span
                  >
                </div>
                <input
                  id="input-fecha-inicial"
                  type="text"
                  class="datepicker center-align"
                  style="cursor: pointer;"
                />
              </div>

              <div class="col s2 input-date" style="cursor: pointer;">
                <link
                  rel="stylesheet"
                  href="https://fonts.googleapis.com/css2?family=Material+Symbols+Outlined:opsz,wght,FILL,GRAD@20..48,100..700,0..1,-50..200"
                />
                <div class="center-align" @click="dateFin">
                  <span
                    class="material-symbols-outlined btn-style "
                    style="position: relative; top: 4px;"
                    >event</span
                  >
                  <span
                    class="prefix"
                    style="font-size: 18px; width: 6rem; top: 0.2rem;"
                    >Fecha Final:</span
                  >
                </div>
                <input
                  id="input-fecha-final"
                  type="text"
                  class="datepicker center-align"
                  style="cursor: pointer;"
                />
              </div>
            </div>
          </div>

          <div class="row intervalos" id="intervalos" >
            <form action="#">
              <div class="col l3">
                <label>
                  <input
                    style="position:static;"
                    @change="fitData('anual')"
                    v-model="periodos"
                    class="with-gap"
                    value="anual"
                    name="periodos"
                    type="radio"
                    checked
                  />
                  <span>Anual</span>
                </label>
              </div>
              <div class="col l3">
                <label>
                  <input
                    class="with-gap"
                    @change="fitData('mensual')"
                    v-model="periodos"
                    name="periodos"
                    value="mensual"
                    type="radio"
                  />
                  <span>Mensual</span>
                </label>
              </div>
              <div class="col l3">
                <label>
                  <input
                    class="with-gap"
                    @change="fitData('semanal')"
                    v-model="periodos"
                    name="periodos"
                    type="radio"
                    value="semanal"
                  />
                  <span>Semanal</span>
                </label>
              </div>
              <div class="col l3">
                <label>
                  <input
                    class="with-gap"
                    v-model="periodos"
                    @change="fitData('diario')"
                    name="periodos"
                    value="diario"
                    type="radio"
                  />
                  <span>Diario</span>
                </label>
              </div>
            </form>
          </div>
          <div v-if="loaded">
            <div v-for="lider in lideres">
              <span>{{ lider.usuario }}</span>
              <line-chart :chartData="lider.graph" :options="options" />
            </div>
          </div>
        </div>
      </div>
    </div>
  </main>
</template>

<script>
import { i18n } from "../constantes";

import LineChart from "./chart.vue";
import { getReportes } from "@/api/api";

export default {
  components: { LineChart },
  name: "graficas",
  data() {
    return {
      loaded: false,
      periodos: "anual",
      chartdata: null,
      options: {
        responsive: true,
        maintainAspectRatio: false,
        fill: false,
      },
      lideres: [],
      plataforma: "0",
      usuarioSeleccionado: "0",
      fechaIni: null,
      fechaFin: null,
    };
  },
  mounted() {
    this.init(), (this.loaded = false);
    document.getElementById("input-fecha-inicial").value = "2019/04/02";
    document.getElementById("input-fecha-final").value = "2021/04/02";
    this.consultar();
  },
  methods: {
    dateIni() {
      const elem = document.getElementById("input-fecha-inicial");
      const instance = M.Datepicker.getInstance(elem);
      instance.open();
      console.log("wea");
    },
    dateFin() {
      const elem = document.getElementById("input-fecha-final");
      const instance = M.Datepicker.getInstance(elem);
      instance.open();
    },
    fitData(filter) {
      this.loaded = false;
      if (filter === "anual") {
        let gr = {};
        let titles;
        this.lideres.forEach((l) => {
          l.graph = {};
          l.transacciones.reverse().forEach((t) => {
            if (!gr[t.fecha.slice(6, 10)]) {
              gr[t.fecha.slice(6, 10)] = 1;
            } else {
              gr[t.fecha.slice(6, 10)] = gr[t.fecha.slice(6, 10)] + 1;
            }
          });

          l.graph = {
            labels: Object.keys(gr),
            datasets: [
              {
                label: "Recargas",
                backgroundColor: `rgb(${Math.floor(
                  Math.random() * 200
                )},${Math.floor(Math.random() * 200)},${Math.floor(
                  Math.random() * 200
                )})`,
                data: Object.keys(gr).map((k) => {
                  return gr[k];
                }),
              },
            ],
          };
          gr = {};
        });
      }
      if (filter === "mensual") {
        let gr = {};
        let titles;
        this.lideres.forEach((l) => {
          l.graph = {};
          l.transacciones.reverse().forEach((t) => {
            if (!gr[t.fecha.slice(3, 10)]) {
              gr[t.fecha.slice(3, 10)] = 1;
            } else {
              gr[t.fecha.slice(3, 10)] = gr[t.fecha.slice(3, 10)] + 1;
            }
          });
          l.graph = {
            labels: Object.keys(gr),
            datasets: [
              {
                label: "Recargas",
                backgroundColor: `rgb(${Math.floor(
                  Math.random() * 200
                )},${Math.floor(Math.random() * 200)},${Math.floor(
                  Math.random() * 200
                )})`,
                data: Object.keys(gr).map((k) => {
                  return gr[k];
                }),
              },
            ],
          };
          gr = {};
        });
      }
      if (filter === "diario") {
        let gr = {};
        let titles;
        this.lideres.forEach((l) => {
          l.transacciones.reverse().forEach((t) => {
            if (!gr[t.fecha]) {
              gr[t.fecha] = 1;
            } else {
              gr[t.fecha] = gr[t.fecha] + 1;
            }
          });
          l.graph = {
            labels: Object.keys(gr),
            datasets: [
              {
                label: "Recargas",
                backgroundColor: `rgb(${Math.floor(
                  Math.random() * 200
                )},${Math.floor(Math.random() * 200)},${Math.floor(
                  Math.random() * 200
                )})`,
                data: Object.keys(gr).map((k) => {
                  return gr[k];
                }),
              },
            ],
          };
          gr = {};
        });
      }
      if (filter === "semanal") {
        let gr = {};
        let titles;
        this.lideres.forEach((l) => {
          l.graph = {};
          l.transacciones.reverse().forEach((t) => {
            let semana = this.getWeek(
              t.fecha.slice(6, 10),
              t.fecha.slice(3, 5),
              t.fecha.slice(0, 2)
            );
            let aniomes = t.fecha.slice(3, 10);
            let location = `${semana}-${aniomes}`;
            if (!gr[location]) {
              gr[location] = 1;
            } else {
              gr[location] = gr[location] + 1;
            }
          });
          l.graph = {
            labels: Object.keys(gr),
            datasets: [
              {
                label: "Recargas",
                backgroundColor: `rgb(${Math.floor(
                  Math.random() * 200
                )},${Math.floor(Math.random() * 200)},${Math.floor(
                  Math.random() * 200
                )})`,
                data: Object.keys(gr).map((k) => {
                  return gr[k];
                }),
              },
            ],
          };
          gr = {};
        });
      }
      this.loaded = true;
    },

    init() {
      this.$nextTick(() => {
        M.updateTextFields();
        M.AutoInit();
        M.Datepicker.init(document.querySelectorAll("#input-fecha-inicial"), {
          format: "yyyy/mm/dd",
          i18n: i18n,
        });

        M.Datepicker.init(document.querySelectorAll("#input-fecha-final"), {
          format: "yyyy/mm/dd",
          i18n: i18n,
        });
      });
    },
    getWeek(y, m, d) {
      var date = new Date(y, m, d);
      date.setHours(0, 0, 0, 0);
      // Thursday in current week decides the year.
      date.setDate(date.getDate() + 3 - ((date.getDay() + 6) % 7));
      // January 4 is always in week 1.
      var week1 = new Date(date.getFullYear(), 0, 4);
      // Adjust to Thursday in week 1 and count number of weeks from date to week1.
      return (
        1 +
        Math.round(
          ((date.getTime() - week1.getTime()) / 86400000 -
            3 +
            ((week1.getDay() + 6) % 7)) /
            7
        )
      );
    },
    consultar() {
      this.loaded = false;

      const fechaIni = document
        .getElementById("input-fecha-inicial")
        .value.trim();
      const fechaFin = document
        .getElementById("input-fecha-final")
        .value.trim();
      let diaIni, mesIni, anioIni, diaFin, mesFin, anioFin;
      if (fechaIni.length > 2) {
        const fechaSeparada = fechaIni.split("/");
        diaIni = fechaSeparada[2];
        mesIni = fechaSeparada[1];
        anioIni = fechaSeparada[0];
      }
      if (fechaFin.length > 2) {
        const fechaSeparada = fechaFin.split("/");
        diaFin = fechaSeparada[2];
        mesFin = fechaSeparada[1];
        anioFin = fechaSeparada[0];
      }
      const auxLider =
        this.usuarioSeleccionado === "0" ? undefined : this.usuarioSeleccionado;
      const auxPlataforma =
        this.plataforma === "0" ? undefined : this.plataforma;

      this.encontrados = "Cargando ...";

      getReportes(diaIni, mesIni, anioIni, diaFin, mesFin, anioFin)
        .then((respuesta) => {
          console.log(respuesta);
          this.loaded = false;
          respuesta.reportes.forEach((key) => {
            let flag = true;
            this.lideres.forEach((lider) => {
              if (key.usuario === lider.usuario) {
                flag = false;
                lider.transacciones.push({
                  dn: key.dn,
                  monto: key.monto,
                  fecha: key.fechaExcel,
                });
              }
            });

            if (flag)
              this.lideres.push({
                usuario: key.usuario,
                transacciones: [
                  {
                    dn: key.dn,
                    monto: key.monto,
                    fecha: key.fechaExcel,
                  },
                ],
              });
          });
          this.fitData("anual");

          this.loaded = true;
        })
        .catch((error) => {
          console.log(error);
        });
    },
  },
};
</script>

<style scoped>
.card-panel {
  border-radius: 10px;
  padding-top: 15px;
  padding-bottom: 15px;
  overflow: auto;
}
.page-title {
  font-weight: inherit;
  font-size: 24px;
  margin-top: auto;
  margin-bottom: auto;
  list-style-type: none;
  display: inline-block;
  padding: 0.75rem 0 1rem;
  color: rgba(0, 0, 0, 0.623);
  -webkit-animation: focus-in-contract 2.1s cubic-bezier(0.25, 0.46, 0.45, 0.94)
    both;
  animation: focus-in-contract 2.1s cubic-bezier(0.25, 0.46, 0.45, 0.94) both;
}
@-webkit-keyframes focus-in-contract {
  0% {
    letter-spacing: 1em;
    -webkit-filter: blur(12px);
    filter: blur(12px);
    opacity: 0;
  }
  100% {
    -webkit-filter: blur(0px);
    filter: blur(0px);
    opacity: 1;
  }
}
@keyframes focus-in-contract {
  0% {
    letter-spacing: 1em;
    -webkit-filter: blur(12px);
    filter: blur(12px);
    opacity: 0;
  }
  100% {
    -webkit-filter: blur(0px);
    filter: blur(0px);
    opacity: 1;
  }
}
.small {
  max-width: 600px;
  margin: 150px auto;
}
.center {
  text-align: center;
}
.main-container {
  width: 94%;
  margin: 0 auto;
}
.col .row {
  margin-left: -0rem;
  margin-right: -0rem;
}
.intervalos{
  margin-top: 8px;
text-align: -webkit-center;
}
</style>
